<!-- i18n対応 -->
<template>
  <div class="text-wrapper">
    {{ $t("aiPredictionReport.expectedSurvivalRateForTheNext10Years", {userName: userName}) }}
  </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
    props: {
      userName: VueTypes.string.isRequired
    }
}
</script>


<style scoped>
  .text-wrapper {
      display: flex;
      justify-content: center;
      font-weight: bold;
  }
</style>
